import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { IUser } from '../../../entity/User'
import { getUrlWithVersion } from '../../../api/api'

export const modifyUser = createAsyncThunk<
    { user: IUser; index: number },
    { user: IUser; index: number },
    ThunkConfig<string>
>('userSlice/modifyUser', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { user, index } = args

    try {
        await api.put(getUrlWithVersion(`/users/${user.login}`), user)
        throwSuccessMessage(`Success!`)

        return { user, index }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to modify user')
    }
})
